import TrackingEventHelper from './models/Event';

export default { events: TrackingEventHelper };
